module.exports = __webpack_public_path__ + "img/tabelSemDados.910d5a40.svg";